import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as valueType from './value-type'

export const DOC = gql`
  ${valueType.DOC}
  fragment FragmentValueWithInfo on ValueWithInfo {
    raw
    info {
      type {
        ...FragmentValueType
      }
      precision
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentValueWithInfoFragment,
  ents.core.common.value.WithInfo.Strict
>({
  precision: {
    usingFullInput: graphql.transformers.OUT.select(
      'info',
      graphql.transformers.OUT.select('precision', transformers.PASS_THROUGH),
    ),
  },
  raw: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.json(),
    ents.core.common.value.Raw.assertIsRaw,
    { warnOnly: true },
  ),
  type: {
    usingFullInput: graphql.transformers.OUT.select<
      graphql.schema.FragmentValueWithInfoFragment,
      ents.core.common.value.WithInfo.Strict['type'] | undefined,
      'info'
    >('info', graphql.transformers.OUT.select('type', valueType.TRANSFORMER)),
  },
})
